import React from "react";
import AppBar from "@mui/material/AppBar";
import Typography from "@mui/material/Typography";
import AccountCircle from "@mui/icons-material/AccountCircle";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/Menu";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import { loggedOut } from "../../redux/slices/authSlice";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
const drawerWidth = 240;
const DashboardHeader = ({ title }) => {
  const authToken = useSelector((state) => state.user.authToken);
  const userData = useSelector((state) => state.user.userData);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const dispatch = useDispatch();
  const location = useLocation();
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleSignOut = () => {
    const data = {
      employee_ID: userData.employee_ID,
      employee_Name: userData.employee_Name,
      login_Logout: "Sign Out",
    };
    var header = {
      Authorization: "Bearer " + authToken,
    };
    dispatch(loggedOut({ data, header }));
  };

  return (
    <AppBar
      position="fixed"
      sx={{
        width: { sm: `calc(100% - ${drawerWidth}px)` },
        ml: { sm: `${drawerWidth}px` },
      }}
      color={"default"}
    >
      <Toolbar>
        <IconButton
          color="inherit"
          aria-label="open drawer"
          edge="start"
          // onClick={handleDrawerToggle}
          sx={{ mr: 2, display: { sm: "none" } }}
        >
          <MenuIcon />
        </IconButton>
        <Typography
          variant="h6"
          component="div"
          sx={{ 
            flexGrow: 1,
            fontWeight: title || location.pathname === "/systemUsageDetailPage" ? 'bold' : 'normal'
          }}
        >
          {title || (location.pathname === "/systemUsageDetailPage" && "System Treatment Record")}
        </Typography>
        <div>
          {/* <IconButton size="large" color="inherit">
            <NotificationsRoundedIcon />
          </IconButton> */}
          <IconButton
            size="large"
            aria-label="account of current user"
            aria-controls="menu-appbar"
            aria-haspopup="true"
            onClick={handleMenu}
            color="inherit"
          >
            <AccountCircle />
          </IconButton>
          <Menu
            id="menu-appbar"
            anchorEl={anchorEl}
            anchorOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            keepMounted
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            open={Boolean(anchorEl)}
            onClose={handleClose}
            disableScrollLock={true}
            disablePortal={true}
          >
            <MenuItem component={Link} to={"/changePassword"}>
              Change Password
            </MenuItem>
            <MenuItem onClick={handleSignOut}>Sign Out</MenuItem>
          </Menu>
        </div>
      </Toolbar>
    </AppBar>
  );
};

export default React.memo(DashboardHeader);
